import React from "react";
import { useForm } from "react-hook-form";

import { useFirebaseListFunction } from "hooks";
import firebase, { FunctionCall } from "firebaseFactory";
import { useAuthDataContext, Permissions } from "modules/auth";
import { FormSubmit } from "components/Form";

interface FormData {
  siteId: string;
}

export const AddSiteToDashboard = ({
  getAllSiteIds,
  addSiteToUser,
}: {
  getAllSiteIds: FunctionCall;
  addSiteToUser: FunctionCall;
}) => {
  const { enforcer, siteIds } = useAuthDataContext();

  const canAddToSite = enforcer.can(Permissions.Users_Manage);

  const {
    data: availableSiteIds,
    isLoading: isLoadingAvailableSiteIds,
  } = useFirebaseListFunction<string>(
    getAllSiteIds,
    {},
    { shouldFetchData: canAddToSite }
  );

  const filteredSiteIds = availableSiteIds.filter(
    (siteId) => !siteIds.includes(siteId)
  );

  const { register, handleSubmit, errors } = useForm<FormData>();

  const onClickSubmit = handleSubmit(async ({ siteId }) => {
    await addSiteToUser.action({
      userId: firebase.auth().currentUser?.uid,
      siteId,
    });
  });

  if (!canAddToSite) return null;
  return (
    <form
      className="bg-white rounded px-6 py-6 flex"
      noValidate
      onSubmit={onClickSubmit}
    >
      <div className="inline-block relative w-64 mr-8">
        <select
          name="siteId"
          id="siteId"
          ref={register({ required: true })}
          className={`${
            errors.siteId ? "border-red-500 " : ""
          } block appearance-none bg-white border border-gray-400 w-full hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline`}
        >
          <option value="">
            ({isLoadingAvailableSiteIds ? "Loading..." : "Select a site"})
          </option>
          {filteredSiteIds.map((siteId, index) => (
            <option key={index}>{siteId}</option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
          <svg
            className="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </div>
      </div>
      <FormSubmit label="Add site" isLoading={isLoadingAvailableSiteIds} />
    </form>
  );
};
